/* eslint-disable */

/**
 * @file
 * A JavaScript file containing the content accordions function. Avoids dependency on Jquery UI.
 *
 */

(function ($, Drupal, drupalSettings) {
  "use strict";

  $(".accordions-tab .accordions-title").on("click", function () {
    const $parent = $(this).parent();
    const $content = $parent.find(".accordions-content");

    if (!$parent.hasClass("active")) {
      $parent.addClass("active").find(".accordions-title").attr("aria-expanded", "true");
      $content.slideDown();
    } else {
      $parent.removeClass("active").find(".accordions-title").attr("aria-expanded", "false");
      $content.slideUp();
    }
  });
})(jQuery, Drupal, drupalSettings);
